// src/pages/components/Layout.js
import React from 'react';
import styled from 'styled-components';

import Navbar from './Navbar';

const Layout = ({ children }) => {
  // Mismo logout que usabas (Navbar lo recibe vía onLogout)
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/login';
  };

  return (
    <Container>
      <NavbarWrapper>
        <Navbar onLogout={handleLogout} />
      </NavbarWrapper>

      <MainContent>
        {children}
      </MainContent>
    </Container>
  );
};

export default Layout;

/* ────────────────────────────── STYLES ────────────────────────────── */
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const NavbarWrapper = styled.header`
  flex-shrink: 0;
`;

const MainContent = styled.main`
  flex: 1;
  overflow-y: auto;
`;
